export const promotionalStatusEnum = {
  OptedOut: 1,
  OptedIn: 2,
  InActive: 3
};

export const promotionalStatusList = [
  { name: "Opted-Out", _id: 1 },
  { name: "Opted-In", _id: 2 },
  { name: "InActive", _id: 3 }
];
